"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pack = void 0;
const class_validator_1 = require("class-validator");
const DateRange_1 = require("./DateRange");
class Pack {
    constructor() {
        this.visible = true;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], Pack.prototype, "id", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], Pack.prototype, "name", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], Pack.prototype, "thumb", void 0);
__decorate([
    class_validator_1.IsBoolean(),
    __metadata("design:type", Boolean)
], Pack.prototype, "visible", void 0);
__decorate([
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_a = typeof DateRange_1.IDateRange !== "undefined" && DateRange_1.IDateRange) === "function" ? _a : Object)
], Pack.prototype, "start", void 0);
__decorate([
    class_validator_1.IsObject(),
    __metadata("design:type", typeof (_b = typeof DateRange_1.IDateRange !== "undefined" && DateRange_1.IDateRange) === "function" ? _b : Object)
], Pack.prototype, "end", void 0);
exports.Pack = Pack;
